// extracted by mini-css-extract-plugin
export default {"root":"VqInH","link-overlay":"_5Il-Y","linkOverlay":"_5Il-Y"};